import { Component, Inject, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Maksutapa } from '@lemon/core-firebase/model/tosite'
import { muotoileKortinNumero } from './maksukortti-logiikka'

export interface MaksukorttiTunnistettuDialogData {
  viimeiset4: string
  maksutapa: Maksutapa
}

export type MaksukorttiTunnistettuDialogTulos = 'yhdista' | 'alaKysy' | undefined

@Component({
  templateUrl: './maksukortti-tunnistettu.dialog.html',
  styleUrls: ['./maksukortti-tunnistettu.dialog.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MaksukorttiTunnistettuDialog {
  kortinNumero: string
  maksutavanNimi: string

  constructor(
    @Inject(MAT_DIALOG_DATA) data: MaksukorttiTunnistettuDialogData,
    private _dialogRef: MatDialogRef<MaksukorttiTunnistettuDialog, MaksukorttiTunnistettuDialogTulos>,
  ) {
    this.kortinNumero = muotoileKortinNumero(data.viimeiset4)
    this.maksutavanNimi = data.maksutapa.l
  }

  yhdista() {
    this._dialogRef.close('yhdista')
  }

  alaKysy() {
    this._dialogRef.close('alaKysy')
  }
}
